import { AccessControlMenuPropsType, MenuItemType } from "../../../types/component.type";
import { AccessControlMenuWrapper } from "./styled";
import { BaseLabel } from "../../form/label/styled";
import { BaseInput } from "../../form/input/styled";
import { Typography } from "@mui/material";

export const AccessControlMenu: React.FC<AccessControlMenuPropsType<MenuItemType>> = ({ open, systemrights, assignedrights, handleCheckboxChange }) => {
    return (
        <AccessControlMenuWrapper
            open={open}
        >
            <form>
                {systemrights?.map((systemright: string, index: string) => (
                    <BaseLabel
                        key={index}
                    >
                        <BaseInput
                            type="checkbox"
                            name={systemright}
                            inputProps={{
                                checked: assignedrights?.includes(systemright),
                            }}
                            onChange={() => handleCheckboxChange?.(systemright)}
                        />
                        <Typography
                            component={"span"}
                            variant="subtitle1"
                            fontFamily={"Inter"}
                            fontWeight={400}
                            fontSize={16}
                            lineHeight={"normal"}
                            color={"var(--dark-color)"}
                        >
                            {systemright}
                        </Typography>
                    </BaseLabel>
                ))}
            </form>
        </AccessControlMenuWrapper>
    )
}
